import React, { useState } from 'react';

const CoursesTab = ({ 
  courses, 
  coursesPagination,
  courseSearchTerm,
  setCourseSearchTerm,
  onCourseSearch,
  onClearCourseSearch,
  onSearchKeyPress,
  onPageChange,
  onShowCreateForm, 
  onEditCourse, 
  onDeleteCourse,
  onDeactivateCourse,
  onActivateCourse
}) => {
  const [viewMode, setViewMode] = useState('grid'); // 'grid' or 'list'

  return (
    <div>
      <div className="flex justify-between items-center mb-8">
        <div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Gerenciar Cursos</h2>
          <p className="text-gray-600">Crie e gerencie cursos para a plataforma</p>
        </div>
        <div className="flex items-center space-x-4">
          {/* Search */}
          <div className="flex-1 max-w-md">
            <div className="flex space-x-2">
              <div className="flex-1 relative">
                <input
                  type="text"
                  value={courseSearchTerm}
                  onChange={(e) => setCourseSearchTerm(e.target.value)}
                  onKeyPress={onSearchKeyPress}
                  placeholder="Buscar cursos..."
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                  <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </div>
              </div>
              <button
                onClick={onCourseSearch}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium transition-colors duration-200 flex items-center"
              >
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                Aplicar
              </button>
              {courseSearchTerm && (
                <button
                  onClick={onClearCourseSearch}
                  className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg font-medium transition-colors duration-200 flex items-center"
                >
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                  Limpar
                </button>
              )}
            </div>
            {courseSearchTerm && (
              <p className="mt-2 text-sm text-blue-600">Buscando por: "{courseSearchTerm}"</p>
            )}
          </div>

          {/* View Mode Toggle */}
          <div className="flex items-center space-x-2">
            <span className="text-sm text-gray-600">Visualização:</span>
            <div className="flex bg-gray-100 rounded-lg p-1">
              <button
                onClick={() => setViewMode('grid')}
                className={`px-3 py-1 rounded-md text-sm font-medium transition-colors duration-200 ${
                  viewMode === 'grid' 
                    ? 'bg-white text-blue-600 shadow-sm' 
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                </svg>
              </button>
              <button
                onClick={() => setViewMode('list')}
                className={`px-3 py-1 rounded-md text-sm font-medium transition-colors duration-200 ${
                  viewMode === 'list' 
                    ? 'bg-white text-blue-600 shadow-sm' 
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16M4 18h16" />
                </svg>
              </button>
            </div>
          </div>
          
          <button
            onClick={onShowCreateForm}
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-xl font-medium transition-colors duration-200 flex items-center space-x-2"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
              />
            </svg>
            <span>Criar Novo Curso</span>
          </button>
        </div>
      </div>

      {/* Courses Display */}
      {viewMode === 'grid' ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {courses.map((course) => (
            <div
              key={course.id}
              className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden group hover:shadow-lg transition-all duration-300"
            >
              {course.background_image && (
                <div
                  className="h-40 bg-cover bg-center"
                  style={{ backgroundImage: `url(${course.background_image})` }}
                >
                  <div className="h-full bg-gradient-to-t from-black/60 to-transparent flex items-end">
                    <div className="p-4">
                      <h3 className="text-lg font-semibold text-white">{course.title}</h3>
                    </div>
                  </div>
                </div>
              )}

              <div className="p-6">
                {!course.background_image && (
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">{course.title}</h3>
                )}
                <p className="text-gray-600 text-sm mb-4 line-clamp-2 whitespace-pre-line">{course.description}</p>

                <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
                  <div className="flex items-center space-x-4">
                    <div className="flex items-center space-x-1">
                      <span>{course.videos.length} vídeos</span>
                    </div>
                    <div className="flex items-center space-x-1">
                      <span>{course.quiz_questions.length} questões</span>
                    </div>
                  </div>
                </div>

                <div className="flex space-x-2">
                  <button
                    onClick={() => onEditCourse(course)}
                    className="flex-1 bg-blue-50 hover:bg-blue-100 text-blue-700 px-3 py-2 rounded-lg text-sm font-medium transition-colors duration-200"
                  >
                    Editar
                  </button>
                  
                  {/* Status indicator */}
                  <div className="flex items-center space-x-1 text-xs">
                    {course.is_active === false ? (
                      <span className="bg-red-100 text-red-800 px-2 py-1 rounded-full">
                        Inativo
                      </span>
                    ) : (
                      <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full">
                        Ativo
                      </span>
                    )}
                    {course.has_certificates && (
                      <span className="bg-yellow-100 text-yellow-800 px-2 py-1 rounded-full">
                        {course.certificates_count} cert.
                      </span>
                    )}
                  </div>
                  
                  {/* Action buttons */}
                  <div className="flex space-x-1">
                    {course.is_active === false ? (
                      <button
                        onClick={() => onActivateCourse(course.id)}
                        className="bg-green-50 hover:bg-green-100 text-green-700 px-3 py-2 rounded-lg text-sm font-medium transition-colors duration-200"
                      >
                        Ativar
                      </button>
                    ) : (
                      <button
                        onClick={() => onDeactivateCourse(course.id)}
                        className="bg-orange-50 hover:bg-orange-100 text-orange-700 px-3 py-2 rounded-lg text-sm font-medium transition-colors duration-200"
                      >
                        Inativar
                      </button>
                    )}
                    
                    {!course.has_certificates && (
                      <button
                        onClick={() => onDeleteCourse(course.id)}
                        className="bg-red-50 hover:bg-red-100 text-red-700 px-3 py-2 rounded-lg text-sm font-medium transition-colors duration-200"
                      >
                        Deletar
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Curso</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Descrição</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Vídeos</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Questões</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ações</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {courses.map((course) => (
                  <tr key={course.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        {course.background_image ? (
                          <div className="flex-shrink-0 h-12 w-12">
                            <img
                              className="h-12 w-12 rounded-lg object-cover"
                              src={course.background_image}
                              alt={course.title}
                            />
                          </div>
                        ) : (
                          <div className="flex-shrink-0 h-12 w-12 bg-blue-100 rounded-lg flex items-center justify-center">
                            <span className="text-blue-600 font-semibold text-lg">📚</span>
                          </div>
                        )}
                        <div className="ml-4">
                          <div className="text-sm font-medium text-gray-900">{course.title}</div>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="text-sm text-gray-900 max-w-xs truncate">{course.description}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="text-sm text-gray-900">{course.videos.length}</span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="text-sm text-gray-900">{course.quiz_questions.length}</span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                      <div className="flex items-center space-x-2">
                        {/* Status indicators */}
                        <div className="flex items-center space-x-1">
                          {course.is_active === false ? (
                            <span className="bg-red-100 text-red-800 px-2 py-1 rounded-full text-xs">
                              Inativo
                            </span>
                          ) : (
                            <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs">
                              Ativo
                            </span>
                          )}
                          {course.has_certificates && (
                            <span className="bg-yellow-100 text-yellow-800 px-2 py-1 rounded-full text-xs">
                              {course.certificates_count} cert.
                            </span>
                          )}
                        </div>
                        
                        {/* Action buttons */}
                        <div className="flex space-x-2">
                          <button
                            onClick={() => onEditCourse(course)}
                            className="text-blue-600 hover:text-blue-900"
                          >
                            Editar
                          </button>
                          
                          {course.is_active === false ? (
                            <button
                              onClick={() => onActivateCourse(course.id)}
                              className="text-green-600 hover:text-green-900"
                            >
                              Ativar
                            </button>
                          ) : (
                            <button
                              onClick={() => onDeactivateCourse(course.id)}
                              className="text-orange-600 hover:text-orange-900"
                            >
                              Inativar
                            </button>
                          )}
                          
                          {!course.has_certificates && (
                            <button
                              onClick={() => onDeleteCourse(course.id)}
                              className="text-red-600 hover:text-red-900"
                            >
                              Deletar
                            </button>
                          )}
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Pagination */}
      {coursesPagination && coursesPagination.total_pages > 1 && (
        <div className="mt-8 flex items-center justify-between">
          <div className="text-sm text-gray-700">
            Mostrando {((coursesPagination.current_page - 1) * coursesPagination.per_page) + 1} a {Math.min(coursesPagination.current_page * coursesPagination.per_page, coursesPagination.total)} de {coursesPagination.total} cursos
          </div>
          <div className="flex items-center space-x-2">
            <button
              onClick={() => onPageChange(coursesPagination.current_page - 1)}
              disabled={!coursesPagination.has_prev}
              className="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Anterior
            </button>
            
            {Array.from({ length: coursesPagination.total_pages }, (_, i) => i + 1).map((page) => (
              <button
                key={page}
                onClick={() => onPageChange(page)}
                className={`px-3 py-2 text-sm font-medium rounded-md ${
                  coursesPagination.current_page === page
                    ? 'bg-blue-600 text-white'
                    : 'text-gray-500 bg-white border border-gray-300 hover:bg-gray-50'
                }`}
              >
                {page}
              </button>
            ))}
            
            <button
              onClick={() => onPageChange(coursesPagination.current_page + 1)}
              disabled={!coursesPagination.has_next}
              className="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Próximo
            </button>
          </div>
        </div>
      )}

      {courses.length === 0 && (
        <div className="text-center py-12">
          <h3 className="text-lg font-medium text-gray-900 mb-2">Nenhum curso criado</h3>
          <p className="text-gray-500 mb-4">Comece criando seu primeiro curso</p>
          <button
            onClick={onShowCreateForm}
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-xl font-medium transition-colors duration-200"
          >
            Criar Primeiro Curso
          </button>
        </div>
      )}
    </div>
  );
};

export default CoursesTab;
